import { BaseService } from './baseService';
import { PatientAllergyDto, PatientAllergyFormData } from '../types/patientAllergy';

class PatientAllergyService extends BaseService<PatientAllergyDto, PatientAllergyFormData> {
    constructor() {
        super('/PatientAllergy');
    }
}

export const patientAllergyService = new PatientAllergyService();